import React from "react";
import { BiSolidDonateHeart } from "react-icons/bi";
function GridOverlay3() {
  return (
    <div className="relative h-56 w-72  flex items-center justify-center bg-gray-100">
      {/* Grid Container */}
      <div className="grid grid-cols-2 h-56 w-72 ">
        {/* Grid Items */}
        <div className="bg-white  h-full w-full"></div>
        <div className="bg-white md:bg-customAqua600 lg:bg-customAqua600  h-full w-full"></div>
        <div className="bg-white h-full w-full"></div>
        <div className="bg-white h-full w-full"></div>
      </div>

      {/* Overlay Div */}
      <div className="absolute p-4 z-10 w-full h-full rounded-[40px] md:rounded-ss-[40px] lg:rounded-ss-[40px] bg-white md:bg-customAqua600 lg:bg-customAqua600 flex flex-col justify-around text-customWhite ">
        <BiSolidDonateHeart className="w-12 h-12 text-customAqua100 " />
        <p className="text-lg font-semibold text-customAqua600 lg:text-white md:text-white">
          Service satisfaisant
        </p>
        <p className="font-normal text-sm text-customAqua600 lg:text-white md:text-white">
          Le patient reçoit des soins dentaires de qualité qui répondent à ses
          attentes ou les dépassent.
        </p>
      </div>
    </div>
  );
}

export default GridOverlay3;
